import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import axios from 'axios';

const AdminEvents = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [formData, setFormData] = useState({
    title: '',
    cover_photo: null,
    description_1: '',
    photo_1: null,
    photo_2: null,
    photo_3: null,
    photo_4: null,
    description_2: '',
    photo_5: null,
    photo_6: null,
    photo_7: null,
    photo_8: null
  });

  useEffect(() => {
    fetchNewsEvents();
  }, []);

  function getCSRFToken() {
    return window.CSRF_TOKEN || '';
  }

  const fetchNewsEvents = async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      const response = await axios.get('/api/news-events', {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-CSRFToken": getCSRFToken(),
        }
      });
      setNewsEvents(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching news events:', error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  const handleAddEvent = async (e) => {
    e.preventDefault();
    
    const data = new FormData();
    data.append('title', formData.title);
    if (formData.cover_photo) data.append('cover_photo', formData.cover_photo);
    if (formData.description_1) data.append('description_1', formData.description_1);
    if (formData.description_2) data.append('description_2', formData.description_2);
    
    for (let i = 1; i <= 8; i++) {
      if (formData[`photo_${i}`]) {
        data.append(`photo_${i}`, formData[`photo_${i}`]);
      }
    }

    try {
      const authToken = localStorage.getItem('authToken');
      await axios.post('/api/news-events', data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-CSRFToken": getCSRFToken(),
          'Content-Type': 'multipart/form-data',
        }
      });

      setMessage({ type: 'success', text: 'News & Event added successfully!' });
      setShowAddModal(false);
      resetForm();
      fetchNewsEvents();
      
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Failed to add news event' });
    }
  };

  const handleEditEvent = async (e) => {
    e.preventDefault();
    
    const data = new FormData();
    if (formData.title) data.append('title', formData.title);
    if (formData.cover_photo) data.append('cover_photo', formData.cover_photo);
    if (formData.description_1 !== null) data.append('description_1', formData.description_1);
    if (formData.description_2 !== null) data.append('description_2', formData.description_2);
    
    for (let i = 1; i <= 8; i++) {
      if (formData[`photo_${i}`]) {
        data.append(`photo_${i}`, formData[`photo_${i}`]);
      }
    }

    try {
      const authToken = localStorage.getItem('authToken');
      await axios.post(`/api/news-events/${selectedEvent.id}`, data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-CSRFToken": getCSRFToken(),
          'Content-Type': 'multipart/form-data',
        }
      });

      setMessage({ type: 'success', text: 'News & Event updated successfully!' });
      setShowEditModal(false);
      setSelectedEvent(null);
      resetForm();
      fetchNewsEvents();
      
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Failed to update news event' });
    }
  };

  const handleDeleteEvent = async (eventId) => {
    if (!window.confirm('Are you sure you want to delete this news event? All associated images will be deleted.')) {
      return;
    }

    try {
      const authToken = localStorage.getItem('authToken');
      await axios.delete(`/api/news-events/${eventId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-CSRFToken": getCSRFToken(),
        }
      });

      setMessage({ type: 'success', text: 'News & Event deleted successfully!' });
      fetchNewsEvents();
      
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Failed to delete news event' });
    }
  };

  const openEditModal = (event) => {
    setSelectedEvent(event);
    setFormData({
      title: event.title,
      cover_photo: null,
      description_1: event.description_1 || '',
      photo_1: null,
      photo_2: null,
      photo_3: null,
      photo_4: null,
      description_2: event.description_2 || '',
      photo_5: null,
      photo_6: null,
      photo_7: null,
      photo_8: null
    });
    setShowEditModal(true);
  };

  const resetForm = () => {
    setFormData({
      title: '',
      cover_photo: null,
      description_1: '',
      photo_1: null,
      photo_2: null,
      photo_3: null,
      photo_4: null,
      description_2: '',
      photo_5: null,
      photo_6: null,
      photo_7: null,
      photo_8: null
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="bg-gray-100 min-h-screen">
        <AdminNavbar />
        <div className="flex items-center justify-center h-96">
          <div className="text-xl text-blue-800">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen">
      <AdminNavbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-blue-800">News & Events Management</h2>
          <button
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition-colors"
          >
            Add New Event
          </button>
        </div>

        {message.text && (
          <div className={`mb-6 p-4 rounded-lg ${
            message.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            {message.text}
          </div>
        )}

        {newsEvents.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <p className="text-gray-600 text-lg">No news events available. Add one to get started.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {newsEvents.map((event) => (
              <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                <img
                  src={event.cover_photo}
                  alt={event.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-blue-800 mb-2">
                    {event.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-4">
                    {formatDate(event.created_at)}
                  </p>
                  {event.description_1 && (
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {event.description_1}
                    </p>
                  )}
                  <div className="flex gap-2">
                    <button
                      onClick={() => openEditModal(event)}
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm transition-colors"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteEvent(event.id)}
                      className="flex-1 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm transition-colors"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Add Event Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full p-6 my-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-blue-800">Add New News & Event</h3>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleAddEvent} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Title <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter event title"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Cover Photo <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  name="cover_photo"
                  accept="image/*"
                  onChange={handleFileChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Description 1
                </label>
                <textarea
                  name="description_1"
                  value={formData.description_1}
                  onChange={handleInputChange}
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter first description"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-4">
                  Photos 1-4 (Optional)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[1, 2, 3, 4].map((num) => (
                    <div key={num}>
                      <label className="block text-sm text-gray-600 mb-1">Photo {num}</label>
                      <input
                        type="file"
                        name={`photo_${num}`}
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Description 2
                </label>
                <textarea
                  name="description_2"
                  value={formData.description_2}
                  onChange={handleInputChange}
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter second description"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-4">
                  Photos 5-8 (Optional)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[5, 6, 7, 8].map((num) => (
                    <div key={num}>
                      <label className="block text-sm text-gray-600 mb-1">Photo {num}</label>
                      <input
                        type="file"
                        name={`photo_${num}`}
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-md font-medium transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition-colors"
                >
                  Add Event
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Event Modal */}
      {showEditModal && selectedEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full p-6 my-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-blue-800">Edit News & Event</h3>
              <button
                onClick={() => {
                  setShowEditModal(false);
                  setSelectedEvent(null);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleEditEvent} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Title
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter event title"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Cover Photo (Leave empty to keep current)
                </label>
                <input
                  type="file"
                  name="cover_photo"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {selectedEvent.cover_photo && (
                  <img src={selectedEvent.cover_photo} alt="Current cover" className="mt-2 h-32 object-cover rounded" />
                )}
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Description 1
                </label>
                <textarea
                  name="description_1"
                  value={formData.description_1}
                  onChange={handleInputChange}
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter first description"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-4">
                  Photos 1-4 (Upload to replace existing)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[1, 2, 3, 4].map((num) => (
                    <div key={num}>
                      <label className="block text-sm text-gray-600 mb-1">Photo {num}</label>
                      <input
                        type="file"
                        name={`photo_${num}`}
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                      {selectedEvent[`photo_${num}`] && (
                        <img src={selectedEvent[`photo_${num}`]} alt={`Photo ${num}`} className="mt-2 h-20 object-cover rounded" />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Description 2
                </label>
                <textarea
                  name="description_2"
                  value={formData.description_2}
                  onChange={handleInputChange}
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter second description"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-4">
                  Photos 5-8 (Upload to replace existing)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[5, 6, 7, 8].map((num) => (
                    <div key={num}>
                      <label className="block text-sm text-gray-600 mb-1">Photo {num}</label>
                      <input
                        type="file"
                        name={`photo_${num}`}
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                      {selectedEvent[`photo_${num}`] && (
                        <img src={selectedEvent[`photo_${num}`]} alt={`Photo ${num}`} className="mt-2 h-20 object-cover rounded" />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    setSelectedEvent(null);
                    resetForm();
                  }}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-md font-medium transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition-colors"
                >
                  Update Event
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEvents;
